module.exports = __webpack_public_path__ + "static/media/3a.76ade1a6.jpg";